/* istanbul ignore file */
export class SmartsheetPushPullFields {
    pushFields: string[];
    pullFields: string[];
    projectId: string;
}
